import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'
import type { EnvironmentServiceSiteConfig } from '../types'

const environmentServiceSiteConfig: SiteConfigFn<EnvironmentServiceSiteConfig> = ({ api, funcLib }) => {
	const isBuilderComponentModel = !!api.rendererModel.getSiteMetaData()?.builderComponentModel
	const isServicesInfra = !!api.env.getExperiments()['specs.thunderbolt.servicesInfra'] || isBuilderComponentModel

	if (!isServicesInfra) {
		return {
			shouldLoadSiteFeature: false,
			shouldLoadSiteConfig: false,
			siteConfig: null,
		}
	}

	const domain = api.publicModel.getDomain()
	const url = api.originalRequest.getUrl() ?? ''
	const editorType = (funcLib.getQueryParamValue(url, 'editorType') || '').toLowerCase()

	const previewMode = api.rendererModel.getPreviewMode()
	const isWixSite = api.rendererModel.getSiteInfo()?.documentType === 'WixSite'

	const trackClicksAnalytics = api.rendererModel.getSitePropertiesInfo()?.trackClicksAnalytics as boolean
	const useSandboxInHTMLComp = api.rendererModel.getUseSandboxInHTMLComp()
	const metaSiteId = api.rendererModel.getMetaSiteId()
	const mainPageId = api.rendererModel.getPageList()?.mainPageId
	const userId = api.rendererModel.getUserId()
	const isInSeo = api.rendererModel.getSeo() || false

	const viewMode = api.env.getViewMode()
	const deviceType = api.publicModel.getNewDeviceInfo()?.deviceClass?.type

	const metaSiteFlags = api.publicModel.getMetaSiteFlags() || []
	const hasUserDomainMedia = metaSiteFlags.includes('UserDomainMedia')
	const externalBaseUrl = api.publicModel.getExternalBaseUrl() ?? ''

	return {
		shouldLoadSiteFeature: true,
		shouldLoadSiteConfig: true,
		siteConfig: {
			previewMode,
			editorType,
			isWixSite,
			trackClicksAnalytics,
			useSandboxInHTMLComp,
			metaSiteId,
			mainPageId,
			userId,
			domain,
			viewMode,
			deviceType,
			isInSeo,
			hasUserDomainMedia,
			externalBaseUrl,
		},
	}
}

const name = 'environmentService'

export const config = { site: environmentServiceSiteConfig, reactNativeSite: environmentServiceSiteConfig, name }
